import { useLang } from "@/contexts/LangContext";
import SectionReveal from "@/components/SectionReveal";
import { CheckCircle2, ArrowRight } from "lucide-react";

const BG =
  "https://images.pexels.com/photos/19425033/pexels-photo-19425033.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

const CantonFair = () => {
  const { t } = useLang();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="canton-fair"
      data-testid="canton-fair-section"
      className="relative bg-[#0A0A0A] text-[#F7F5F0] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <SectionReveal className="lg:col-span-6">
            <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#D4AF37] font-semibold mb-4">
              ✦ {t.canton.eyebrow}
            </p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              {t.canton.title}
            </h2>
            <p className="mt-8 text-lg text-white/75 leading-relaxed max-w-xl">
              {t.canton.subtitle}
            </p>

            <ul className="mt-10 space-y-4">
              {t.canton.bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`canton-bullet-${i}`}
                  className="flex items-start gap-3 text-white/85"
                >
                  <CheckCircle2
                    size={20}
                    className="text-[#D4AF37] mt-0.5 flex-shrink-0"
                  />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="canton-fair-inquiry-button"
              onClick={() => scrollTo("contact")}
              className="mt-12 group bg-[#D4AF37] hover:bg-[#bf9a2b] text-[#0A0A0A] px-8 py-4 uppercase tracking-wider text-sm font-semibold inline-flex items-center gap-3 transition-all duration-300"
            >
              {t.canton.cta}
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </SectionReveal>

          <SectionReveal delay={0.2} className="lg:col-span-6">
            <div className="relative aspect-[4/5] overflow-hidden border border-[#D4AF37]/20">
              <img
                src={BG}
                alt="Canton Fair business exhibition"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="font-heading text-3xl md:text-4xl">Pazhou · Guangzhou</p>
                <p className="text-sm text-white/70 mt-2">Spring & Autumn sessions</p>
              </div>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>
  );
};

export default CantonFair;
